import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import TargetRegularQuota from './target-regular-quota-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <TargetRegularQuota {...validProps} />;
}

SvgComponent.iconName = 'target-regular-quota';

export const TargetRegularQuotaIcon = svgIconWrapper(SvgComponent);
